import clsx from "clsx";
import PureInput from "@/components/common/form/PureInput";

const Input = ({
  id,
  label,
  placeholder,
  register,
  rules,
  children,
  className,
  inputClass,
  autoComplete,
  subTitle,
  ...inputProps
}) => (
  <div className={`flex w-full flex-col space-y-1 ${className || ""}`}>
    <label htmlFor={id} className={clsx("text-sm", subTitle && "font-semibold")}>
      {label}
    </label>
    {subTitle && <div className="text-gray-600 text-sm">{subTitle}</div>}
    <PureInput
      {...inputProps}
      register={register}
      rules={rules}
      id={id}
      placeholder={placeholder}
      className={clsx(inputClass, children && "border-red")}
      autoComplete={autoComplete}
    />
    {children && <span className="text-sm text-red">{children}</span>}
  </div>
);

export default Input;
